import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
// imported cookie service
import { CookieService } from 'ngx-cookie-service';

import { FilterDate, FilterDateInterface } from '../../models';

@Component({
  selector: 'cz-site-date-filter-menu',
  templateUrl: './site-date-filter-menu.component.html',
  styleUrls: ['./site-date-filter-menu.component.scss'],
})
export class SiteDateFilterMenuComponent implements OnInit {

  public filterDateFormGroup: FormGroup;
  public dateFilterBtnActive: boolean;
  // boolean variable delaration
  public isSpanish: boolean = false;

  @Input()
  set filterDateData(value: FilterDateInterface) {
    this._filterDataDate = value;
    this.updateDate();
  }
  get filterDateData(): FilterDateInterface {
    return this._filterDataDate;
  }

  @Output() public getFilterDates: EventEmitter<FilterDateInterface> = new EventEmitter<FilterDateInterface>();
  @ViewChild(MatMenuTrigger) public trigger: MatMenuTrigger;

  private _filterDataDate: FilterDateInterface;

  constructor(private _formBuilder: FormBuilder, private readonly _cookieService: CookieService) {
    // checking condition for culture(cookie) value is french to update boolean value
    if (this._cookieService.get('Culture') !== 'en') {
      this.isSpanish = true;
    }
    this.filterDateFormGroup = this._formBuilder.group(this.createDateFilterForm());
  }

  public ngOnInit(): void { }

  public updateDate(): void {
    if(!this.filterDateData || !this.filterDateFormGroup) {
      return;
    }

    this.setInitialFilterState(this.filterDateData);
    this.dateFilterBtnActive = this.filterDateData.isActive;
  }

  // Closes a filter menu "X"
  public closeFilterMenu(): void {
    // Reset the form if the apply button isn't clicked
    this.setInitialFilterState(this.filterDateData);
    this.dateFilterBtnActive = this.filterDateData.isActive;

    this.trigger.closeMenu();
  }

  public clearDateFilter(): void {
    const filterDateData: FilterDate = new FilterDate({
      endDate: undefined,
      startDate: undefined,
      isActive: false,
    });

    this.filterDateFormGroup.get('fromDateControl').setValue('');
    this.filterDateFormGroup.get('toDateControl').setValue(new Date(Date.now()));

    this.dateFilterBtnActive = false;

    this.getFilterDates.emit(filterDateData);

    this.trigger.closeMenu();
  }

  public dateFilterActive(): void {
    const filterDateData: FilterDate = new FilterDate({
      endDate: this.filterDateFormGroup.get('toDateControl').value,
      startDate: this.filterDateFormGroup.get('fromDateControl').value,
      isActive: true,
    });

    this.dateFilterBtnActive = true;

    this.getFilterDates.emit(filterDateData);

    this.trigger.closeMenu();
  }

  private createDateFilterForm(): {} {
    const group: { [id: string]: FormControl } = {
      ['fromDateControl']: new FormControl(''),
      ['toDateControl']: new FormControl(''),
    };

    return group;
  }

  private setInitialFilterState(filterDate: FilterDateInterface): void {
    this.filterDateFormGroup.get('fromDateControl').setValue(filterDate.startDate ? filterDate.startDate : '');
    this.filterDateFormGroup.get('toDateControl').setValue(filterDate.endDate ? filterDate.endDate : new Date(Date.now()));
  }
}
